import styled from 'styled-components'

import { ButtonPlain } from '@subaio/components'

import { helpers } from 'styles'

export const Button = styled(ButtonPlain)`
	min-height: 24px;
	padding: 4px 12px;
	border: 0;
	border-radius: 30px;
	background: transparent;
	color: ${helpers.color.text};
	font-size: ${helpers.font.size.small};
	text-align: center;
	font-weight: 400;

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&[aria-selected='true'] {
		background-color: ${helpers.color.background};
		font-weight: 600;
	}
`
